import React from 'react';
import { Percent, ArrowRight, Check, Gift } from 'lucide-react';
import { Button } from '../ui/button';
import { Card, CardContent } from '../ui/card';
import Navbar from '../Navbar';
import Footer from '../Footer';
import { useAuth } from '../../context/AuthContext';

const PromotionsPage = () => {
  const { login } = useAuth();
  const features = ['Cupons automáticos', 'Ofertas segmentadas', 'Campanhas sazonais', 'Rastreamento de uso'];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main className="pt-28 pb-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <div className="inline-flex items-center gap-2 bg-orange-100 text-orange-700 px-4 py-2 rounded-full text-sm font-medium mb-6">
                <Percent className="h-4 w-4" />Promoções
              </div>
              <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
                <span className="text-orange-500">Promoções</span> automatizadas
              </h1>
              <p className="text-xl text-gray-600 mb-8">Envie cupons e ofertas personalizadas automaticamente para seus clientes.</p>
              <Button onClick={login} size="lg" className="bg-[#3b82f6] hover:bg-[#2563eb]">Começar gratuitamente</Button>
            </div>
            <div className="bg-orange-50 rounded-3xl p-6">
              <div className="bg-white rounded-2xl p-6 text-center">
                <Gift className="h-12 w-12 text-orange-500 mx-auto mb-4" />
                <p className="font-bold text-2xl mb-2">20% OFF</p>
                <p className="text-gray-600 mb-4">Use o código: CHATALFA20</p>
                <Button className="w-full bg-orange-500 hover:bg-orange-600">Usar cupom</Button>
              </div>
            </div>
          </div>
        </div>
        <div className="bg-gray-50 py-16">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">Recursos</h2>
            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
              {features.map((f) => (<div key={f} className="bg-white rounded-xl p-6 shadow-sm"><Check className="h-6 w-6 text-green-500 mb-3" /><p className="font-medium text-gray-900">{f}</p></div>))}
            </div>
          </div>
        </div>
        <div className="py-16"><div className="max-w-4xl mx-auto px-4"><Card className="bg-gradient-to-br from-[#3b82f6] to-[#1d4ed8] text-white"><CardContent className="py-12 text-center"><h2 className="text-2xl font-bold mb-4">Crie promoções que convertem</h2><Button onClick={login} variant="secondary" size="lg" className="bg-white text-[#3b82f6] hover:bg-gray-100">Começar agora <ArrowRight className="ml-2 h-4 w-4" /></Button></CardContent></Card></div></div>
      </main>
      <Footer />
    </div>
  );
};
export default PromotionsPage;
